import type { ReactNode } from 'react'

import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

/** Shared label typography for settings rows and table rows (`text-[13px]`). */
export function SettingsFieldLabel({
  children,
  className,
  htmlFor,
}: {
  children: ReactNode
  className?: string
  htmlFor?: string
}) {
  return (
    <Label htmlFor={htmlFor} className={cn('text-[13px] font-medium', className)}>
      {children}
    </Label>
  )
}

/** Shared description typography under settings labels. */
export function SettingsFieldDescription({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <p className={cn('mt-0.5 text-xs leading-4 text-muted-foreground', className)}>
      {children}
    </p>
  )
}
